import React, { useState } from 'react';
import SortTypeDropdown from '../common/SortTypeDropdown';
import { useUserSettings, useUserSettingsDispatch } from '../common/UserSettingsProvider';

export default function LiveSortButton() {
    const userSettings = useUserSettings();
    const dispatch = useUserSettingsDispatch();
    const [toggled, setToggled] = useState(false);

    function toggle() {
        setToggled(!toggled);
    }

    function changeSortType(liveSortingType) {
        dispatch({type: 'setLiveSortingType', liveSortingType});
    }

    const type = userSettings.liveSortingType;

    return (
        <>
            <i className="bi-arrow-down-up text-lg text-cs1" onClick={toggle} />
            {toggled &&
                <SortTypeDropdown toggle={toggle} setSortType={changeSortType} current={type} />
            }
            {/* {toggled &&
                <div className="z-50 absolute top-[36px] right-[0px] w-[220px] h-fit py-1 flex flex-col text-xs bg-cs1 rounded-md shadow-sm shadow-shadow">
                    <div className="h-[40px] w-full px-2 flex items-center border-b border-b-cs7">
                        <i className="ml-auto bi-x-lg text-xl" onClick={toggle} />
                    </div>
                    <div className={"h-[40px] px-2 flex items-center" + classIf(type === 'league', 'bg-cs4 text-cs1')} onClick={() => changeSortType('league')}>
                        <span>{getLabel('live.navbar.sort_popup.sort_by_tournament)}</span>
                    </div>
                    <div className={"h-[40px] px-2 flex items-center" + classIf(type === 'asc', 'bg-cs4 text-cs1')} onClick={() => changeSortType('asc')}>
                        <span>{getLabel('live.navbar.sort_button.sort_by_chronological_order)}</span>
                    </div>
                    <div className={"h-[40px] px-2 flex items-center" + classIf(type === 'desc', 'bg-cs4 text-cs1')} onClick={() => changeSortType('desc')}>
                        <span>{getLabel('live.navbar.sort_button.sort_by_reverse_chronological_order')}</span>
                    </div>
                </div>
            } */}
        </>
    );
}
